import { AfterViewInit, Component, ComponentRef, ViewChild, ViewContainerRef } from "@angular/core";
import { PreviewItemFilterFactory } from "./preview-item-filter.factory";
import { GameType, ItemType } from "@apiserver-rest/ponder-data-client-base";
import { PreviewItemFilters } from "./preview-item-filters";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { Subscription, take } from "rxjs";
import { AuthService } from "@ponder-core/auth/auth.service";
import { PreviewItemFilterOptionComponent } from "./preview-item-filter-option.component";
import { FilterType } from "./preview-item-filter-option";
import { PreviewItemFilterOptionSelectComponent } from "./impl/preview-item-filter-option-select.component";
import { PreviewItemFilterOptionInputComponent } from "./impl/preview-item-filter-option-input.component";
import { PreviewItemFilterOptionSortComponent } from "./impl/preview-item-filter-option-sort.component";
import { MagicCardFilterOptionColorComponent } from "@ponder-features/magic/card/filter/options/magic-card-filter-option-color.component";
import { MagicCardFilterOptionManaComponent } from "@ponder-features/magic/card/filter/options/magic-card-filter-option-mana.component";
import { AuthSession } from "@ponder-core/auth/auth-session";

/**
 * Used to filter/sort preview items (cards)
 */
@Component({
    selector: "preview-item-filter",
    imports: [],
    templateUrl: "./preview-item-filter.component.html"
})
export class PreviewItemFilterComponent implements AfterViewInit {
    public itemFilters!: PreviewItemFilters;

    private filterReadySub!: Subscription;
    private isFilterReady: boolean = false;
    private isAuthed?: boolean;
    private isInCollection: boolean = false;
    
    @ViewChild("filterOptions", { read: ViewContainerRef }) private filterOptionsVcr!: ViewContainerRef;
    
    public constructor(filterFactory: PreviewItemFilterFactory, events: EventBroker, private auth: AuthService) {
        this.filterReadySub = events.ui.previewItemFilterReadyEvent.subscribe({
            next: () => {
                this.isFilterReady = true;
                this.createFilterOptions();
            }
        });

        this.itemFilters = filterFactory.build(GameType.Magic, ItemType.Card);
        this.itemFilters.setUserInfo(false, this.auth.isAuthed());

        events.ui.enteredCollectionEvent
            .pipe(take(1))
            .subscribe({
                next: () => {
                    this.isInCollection = true;

                    if (this.isAuthed != undefined) {
                        this.itemFilters.setUserInfo(this.isInCollection, this.isAuthed);
                    } // else if isAuthed is not set yet, then the user info will be set when that async action returns
                }
            });
    }

    public ngOnDestroy(): void {
        this.filterReadySub?.unsubscribe();
    }

    public ngOnInit(): void {
        this.auth.getSessionAsync().then((authSession?: AuthSession) => {
            this.isAuthed = (authSession ? true : false);
            this.itemFilters.setUserInfo(this.isInCollection, this.isAuthed);
        });
    }

    public ngAfterViewInit(): void {
        this.createFilterOptions();
    }

    private createFilterOptions(): void {
        if (!this.isFilterReady || !this.filterOptionsVcr) {
            return;
        }

        this.itemFilters.getFilterOptions()?.forEach(o => {
            var itemFilterOptionRef = this.createFilterOptionComponent(o.filterType);

            if (itemFilterOptionRef?.instance) {
                itemFilterOptionRef.instance.itemFilters = this.itemFilters;
                itemFilterOptionRef.instance.filterOption = o;
            }
        });
    }

    private createFilterOptionComponent(type: FilterType): ComponentRef<PreviewItemFilterOptionComponent> | undefined {
        switch (type) {
            case FilterType.Select:
                return this.filterOptionsVcr.createComponent(PreviewItemFilterOptionSelectComponent);

            case FilterType.Text:
                return this.filterOptionsVcr.createComponent(PreviewItemFilterOptionInputComponent);

            case FilterType.Sort:
                return this.filterOptionsVcr.createComponent(PreviewItemFilterOptionSortComponent);

            case FilterType.MagicColorIdentity:
                return this.filterOptionsVcr.createComponent(MagicCardFilterOptionColorComponent);

            case FilterType.MagicManaProduction:
                return this.filterOptionsVcr.createComponent(MagicCardFilterOptionManaComponent);

            default:
                return undefined;
        }
    }
}